import EmptylMessageIcon from '@shared/assets/images/info_circle.svg';

import styles from '@pages/admin/organization/components/DisabledOrganizationList/DisabledOrganizationList.module.scss';
const STATUS_MAP = {
  0: { label: '운영', className: 'active' },
  1: { label: '중지', className: 'paused' },
  2: { label: '폐지', className: 'disabled' },
};
export default function DisabledOrganizationList({ teams, selectedNode, onSelectNode }) {
  if (teams.length === 0) {
    return (
      <div className={styles.emptyMessage}>
        <img src={EmptylMessageIcon} alt="" />
        <p>미사용 조직이 없습니다.</p>
      </div>
    );
  }

  return (
    <div className={styles.table}>
      {/* ===== Header ===== */}
      <div className={styles.headerRow}>
        <span>조직명</span>
        <span>운영상태</span>
      </div>

      {/* ===== Body ===== */}
      <div className={styles.body}>
        {teams.map((team) => {
          const isSelected = selectedNode?.key === team.teamCode;
          const status = STATUS_MAP[team.enabled];

          return (
            <div
              key={team.teamCode}
              className={`${styles.bodyRow} ${isSelected ? styles.selected : ''}`}
              onClick={() =>
                onSelectNode({
                  nodeType: 'TEAM',
                  key: team.teamCode,
                  raw: team,
                })
              }
            >
              <span className={styles.teamName}>{team.team}</span>

              <span className={`${styles.statusBadge} ${status?.className}`}>
                {status?.label ?? '알 수 없음'}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
